export const generalFontWeight = [
  { label: "styles.fields.weightOpts.regular", value: "400" },
  { label: "styles.fields.weightOpts.medium", value: "500" },
  { label: "styles.fields.weightOpts.bold", value: "700" },
  { label: "styles.fields.weightOpts.italic", value: "italic" },
];

export const thicknessOptions = [
  { label: "0px", value: 0 },
  { label: "1px", value: 1 },
  { label: "2px", value: 2 },
  { label: "3px", value: 3 },
  { label: "4px", value: 4 },
];

export const selectorOptions = [
  { label: "Bullet", value: "bullet" },
  { label: "Checkbox", value: "checkbox" },
];

export const generalFontSize = [
  { label: "6px", value: 6 },
  { label: "8px", value: 8 },
  { label: "10px", value: 10 },
  { label: "12px", value: 12 },
  { label: "14px", value: 14 },
  { label: "16px", value: 16 },
  { label: "18px", value: 18 },
  { label: "20px", value: 20 },
  { label: "22px", value: 22 },
  { label: "24px", value: 24 },
  { label: "26px", value: 26 },
  { label: "28px", value: 28 },
  { label: "30px", value: 30 },
  { label: "32px", value: 32 },
  { label: "34px", value: 34 },
  { label: "36px", value: 36 },
];

export const borderRadiusPXOptions = [
  { label: "1px", value: 1 },
  { label: "2px", value: 2 },
  { label: "4px", value: 4 },
  { label: "6px", value: 6 },
  { label: "8px", value: 8 },
  { label: "10px", value: 10 },
  { label: "12px", value: 12 },
  { label: "14px", value: 14 },
  { label: "16px", value: 16 },
  { label: "18px", value: 18 },
  { label: "20px", value: 20 },
  { label: "22px", value: 22 },
  { label: "24px", value: 24 },
];

export const borderRadiusButtonOptions = [
  { label: "Rounded", value: "rounded" },
  { label: "Square", value: "square" },
  { label: "Pill", value: "pill" },
];

export const borderRadiusOptions = [
  ...borderRadiusButtonOptions,
  { label: "Linear", value: "linear" },
];

export const getStyle = (style) => {
  switch (style) {
    case "rounded":
      return {
        borderRadius: "8px",
      };
    case "square":
      return {
        borderRadius: 0,
      };
    case "pill":
      return {
        borderRadius: "27px",
      };
    case "linear":
      return {
        borderTopColor: "transparent",
        borderLeftWidth: "0px",
        borderRightWidth: "0px",
        borderBottomWidth: "1px",
        borderStyle: "solid",
      };
  }
};
